import { render, staticRenderFns } from "./jpLanguageList.vue?vue&type=template&id=97cb5df4&scoped=true&"
import script from "./jpLanguageList.vue?vue&type=script&lang=js&"
export * from "./jpLanguageList.vue?vue&type=script&lang=js&"
import style0 from "./jpLanguageList.vue?vue&type=style&index=0&id=97cb5df4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cb5df4",
  null
  
)

export default component.exports